export default __webpack_public_path__ + "static/media/Hat-Wizard.91b88b34.svg";